import { Commands } from "@rhinov/savane-js";

export var scripts = document.getElementsByTagName("script");
export type Command = InstanceType< typeof Commands.Command>;
export var COCOS_PLAN_MODULE_PATH: string | null = null;
for (var i = 0; i < scripts.length; ++i) {
    var s = scripts.item(i);
    if (s && s.src && s.src.match('cocosPlan.min.js')) {
        COCOS_PLAN_MODULE_PATH = s.src.substring(0, s.src.lastIndexOf("/") + 1);
    }
}
if (COCOS_PLAN_MODULE_PATH === null) {
    COCOS_PLAN_MODULE_PATH = 'node_modules/@rhinov/cocos-plan'
}

//chercher asset_manager_address et  asset_manager_key  et asset_manager_address_api
// assetmanager pour les chemins en durs

export var CocosConstants = {
    SpriteRatio: 0.2,
    sketchMode: false,
    autosaveCookieName: 'autoSave',
    resourcesBasePath: COCOS_PLAN_MODULE_PATH + '/cocos',

    get asset_manager_address_api() {
        console.error('you have to update your code and use AssetManagerModule');
        return null;
    },
    get asset_manager_address() {
        console.error('you have to update your code and use AssetManagerModule');
        return null;
    },
    get asset_manager_key() {
        console.error('you have to update your code and use AssetManagerModule');
        return null;
    }
};

export var HP_GLOBAL_RESOURCES = {
    resourcesBasePath: "",
    resources: {
        list: [] as string[]
    }
};

